const route = (resolve) => {
  return ['$q', function ($q) {
    const defer = $q.defer();
    resolve(defer.resolve);
    return defer.promise;
  }]
};

export default app => {
  const $inject = ['$urlRouterProvider', '$stateProvider'];

  const LbRoutes = function ($urlRouterProvider, $stateProvider) {

    $urlRouterProvider.otherwise(($injector) => {
      const $state = $injector.get('$state');

      $state.go('404', {
        prev: {
          state: $state.current,
          params: $state.params
        }
      }, {
        location: false
      });
    });

    $stateProvider
      .state('authenticate', {
        url: '/authenticate',
        template: '<sct-authenticate/>',
        resolve: {
          async: route(callback =>
            require.ensure([], () => {
                const component = require('../components/sct/sctAuthenticate/sctAuthenticate').name;
                callback(app.register(component));
              }
            )
          )
        },
        params: {
          pageTitle: 'Authenticating, please wait....',
          isPublic: true
        }
      })

      .state('landing', {
        abstract: true,
        template: '<sct-landing/>',
        resolve: {
          async: route(callback =>
            require.ensure([], () => {
                const sctLanding = require('../components/sct/sctLanding/sctLanding').name;
                callback(app.register(sctLanding));
              }
            )
          ),
          logout: ['authService', function (authService) {
            return authService.logout();
          }]
        },
        params: {
          isPublic: true
        }
      })

      .state('landing.login', {
        url: '/login',
        template: '<sct-login/>',
        resolve: {
          async: route(callback =>
            require.ensure([], () => {
                const sctLogin = require('../components/sct/sctLogin/sctLogin').name;
                callback(app.register(sctLogin));
              }
            )
          )
        },
        params: {
          pageTitle: 'Sign In',
          callback: ''
        }
      })

      .state('landing.signUp', {
        url: '/sign-up',
        template: '<sct-sign-up/>',
        resolve: {
          async: route(callback =>
            require.ensure([], () => {
                const component = require('../components/sct/sctSignUp/sctSignUp').name;
                callback(app.register(component));
              }
            )
          )
        },
        params: {
          pageTitle: 'Sign Up'
        }
      })

      .state('landing.signUpSuccess', {
        url: '/sign-up/success',
        template: require('../components/sct/sctSignUp/sctSignUpSuccess.html'),
        params: {
          pageTitle: 'Sign Up Success'
        }
      })

      .state('landing.forgot', {
        url: '/forgot',
        template: '<sct-forgot/>',
        resolve: {
          async: route(callback =>
            require.ensure([], () => {
                const sctForgot = require('../components/sct/sctForgot/sctForgot').name;
                callback(app.register(sctForgot));
              }
            )
          )
        },
        params: {
          pageTitle: 'Forgot Password',
          hasExpired: false
        }
      })

      .state('landing.reset', {
        url: '/reset',
        template: '<sct-reset/>',
        resolve: {
          async: route(callback =>
            require.ensure([], () => {
                const sctReset = require('../components/sct/sctReset/sctReset').name;
                callback(app.register(sctReset));
              }
            )
          )
        },
        params: {
          pageTitle: 'Reset Password',
          isPublic: true
        }
      })


      .state('app.registration', {
        url: '/register',
        template: '<ui-view/>',
        redirectTo: 'app.registration.profile'
      })


      .state('app.registration.profile', {
        url: '/profile',
        template: '<sct-registration-profile/>',
        resolve: {
          async: route(callback =>
            require.ensure([], () => {
                const component = require('../components/sct/sctRegistration/sctRegistrationProfile/sctRegistrationProfile').name;
                callback(app.register(component));
              }
            )
          )
        },
        params: {
          pageTitle: 'Register - Profile'
        }
      })

      .state('app.registration.paymentMethod', {
        url: '/payment-method',
        template: '<sct-registration-payment/>',
        resolve: {
          async: route(callback =>
            require.ensure([], () => {
                const component = require('../components/sct/sctRegistration/sctRegistrationPayment/sctRegistrationPayment').name;
                callback(app.register(component));
              }
            )
          )
        },
        params: {
          pageTitle: 'Register - Payment Method'
        }
      })

      .state('app.registration.invite', {
        url: '/invite',
        template: '<sct-registration-invite/>',
        resolve: {
          async: route(callback =>
            require.ensure([], () => {
                const component = require('../components/sct/sctRegistration/sctRegistrationInvite/sctRegistrationInvite').name;
                callback(app.register(component));
              }
            )
          )
        },
        params: {
          pageTitle: 'Register - Invite Team'
        }
      })

      .state('invited', {
        url: '/invited',
        template: '<sct-invited/>',
        resolve: {
          async: route(callback =>
            require.ensure([], () => {
                const component = require('../components/sct/sctInvited/sctInvited').name;
                callback(app.register(component));
              }
            )
          )
        },
        params: {
          pageTitle: 'Invited',
          isPublic: true
        }
      })

      .state('invitedSuccess', {
        url: '/invited/success',
        template: '<sct-invited-success/>',
        resolve: {
          async: route(callback =>
            require.ensure([], () => {
                const component = require('../components/sct/sctInvited/sctInvitedSuccess').name;
                callback(app.register(component));
              }
            )
          )
        },
        params: {
          pageTitle: 'Invite Success',
          isPublic: true
        }
      })

      .state('terms', {
        url: '/terms',
        template: '<sct-terms/>',
        resolve: {
          async: route(callback =>
            require.ensure([], () => {
                const sctTerms = require('../components/sct/sctTerms/sctTerms').name;
                callback(app.register(sctTerms));
              }
            )
          )
        },
        params: {
          pageTitle: 'Terms',
          isPublic: true
        }
      })

      .state('app.home.search', {
        url: '/search',
        template: '<lb-home-search splash-app="\'sct\'"></lb-home-search>',
        resolve: {
          async: route(callback =>
            require.ensure([], () => {
              const lbHomeSearch = require('../components/lbHomeSearch').name;
              callback(app.register(lbHomeSearch))
              }
            )
          )
        },
        params: {
          pageTitle: 'New Search',
          bodyClass: 'bg-search'
        }
      })

      .state('404', {
        url: '/error',
        template: '<sct-404/>',
        resolve: {
          async: route(callback =>
            require.ensure([], () => {
                const component = require('../components/sct/sct404/sct404').name;
                callback(app.register(component));
              }
            )
          )
        },
        params: {
          isPublic: true,
          pageTitle: 'Page not found',
          bodyClass: 'bg-404',
          prev: null
        }
      })

      .state('app.admin', {
        url: '/admin',
        redirectTo: 'app.admin.activity',
        template: '<sct-admin/>',
        resolve: {
          async: route(callback =>
            require.ensure([], () => {
                const component = require('../components/sct/sctAdmin/sctAdmin').name;
                callback(app.register(component));
              }
            )
          )
        },
        params: {
          pageTitle: 'Admin',
          bodyClass: 'bg-sct'
        }
      })

      .state('app.admin.activity', {
        linkTitle: 'Activity',
        pageTitle: 'Activity',
        url: '/activity',
        template: '<sct-activity/>',
        resolve: {
          async: route(callback =>
            require.ensure([], () => {
                const component = require('../components/sct/sctAdmin/sctActivity/sctActivity').name;
                callback(app.register(component))
              }
            )
          )
        },
        params: {
          pageTitle: 'Activity',
          userPermissionLvlRequired: ['Admin', 'Booker']
        }
      })

      .state('app.admin.payment', {
        url: '/payment',
        redirectTo: 'app.admin.payment.options',
        template: '<ui-view/>',
        params: {
          userPermissionLvlRequired: ['Admin']
        }
      })

      .state('app.admin.payment.options', {
        template: '<sct-payment/>',
        resolve: {
          async: route(callback =>
            require.ensure([], () => {
                const component = require('../components/sct/sctAdmin/sctPayment/sctPayment').name;
                callback(app.register(component));
              }
            )
          )
        },
        params: {
          linkTitle: 'Payment',
          pageTitle: 'Payment',
          userPermissionLvlRequired: ['Admin']
        }
      })

      .state('app.admin.payment.add', {
        url: '/add',
        template: '<sct-add-payment-method/>',
        resolve: {
          async: route(callback =>
            require.ensure([], () => {
                const component = require('../components/sct/sctAdmin/sctPaymentMethod/sctAddPaymentMethod').name;
                callback(app.register(component));
              }
            )
          )
        },
        params: {
          linkTitle: 'Add payment method',
          pageTitle: 'Add payment method',
          userPermissionLvlRequired: ['Admin']
        }
      })

      .state('app.admin.payment.edit', {
        url: '/edit/:id',
        template: '<sct-edit-payment-method/>',
        resolve: {
          async: route(callback =>
            require.ensure([], () => {
                const component = require('../components/sct/sctAdmin/sctPaymentMethod/sctEditPaymentMethod').name;
                callback(app.register(component));
              }
            )
          )
        },
        params: {
          linkTitle: 'Edit payment method',
          pageTitle: 'Edit payment method',
          userPermissionLvlRequired: ['Admin']
        }
      })

      .state('app.admin.people', {
        url: '/people',
        redirectTo: 'app.admin.people.list',
        template: '<ui-view/>'
      })

      .state('app.admin.people.list', {
        template: '<sct-people/>',
        resolve: {
          async: route(callback =>
            require.ensure([], () => {
                const component = require('../components/sct/sctAdmin/sctPeople/sctPeople').name;
                callback(app.register(component));
              }
            )
          )
        },
        params: {
          linkTitle: 'People',
          pageTitle: 'People',
          userPermissionLvlRequired: ['Admin', 'Booker']
        }
      })

      .state('app.admin.people.view', {
        url: '/view/:id',
        template: '<sct-user-profile/>',
        resolve: {
          async: route(callback =>
            require.ensure([], () => {
                const component = require('../components/sct/sctAdmin/sctPeople/sctUserProfile/sctUserProfile').name;
                callback(app.register(component));
              }
            )
          )
        },
        params: {
          linkTitle: 'People',
          pageTitle: 'View Profile',
          userPermissionLvlRequired: ['Admin', 'Booker']
        }
      })

      .state('app.admin.invite', {
        url: '/invite',
        template: '<sct-invite-team/>',
        resolve: {
          async: route(callback =>
            require.ensure([], () => {
                const component = require('../components/sct/sctAdmin/sctInviteTeam/sctInviteTeam').name;
                callback(app.register(component));
              }
            )
          )
        },
        params: {
          linkTitle: 'Invite',
          pageTitle: 'Invite',
          userPermissionLvlRequired: ['Admin', 'Booker']
        }
      })

      .state('app.admin.bookingRules', {
        url: '/booking-rules',
        template: '<sct-booking-rules/>',
        resolve: {
          async: route(callback =>
            require.ensure([], () => {
                const sctBookingRules = require('../components/sct/sctAdmin/sctBookingRules/sctBookingRules').name;
                callback(app.register(sctBookingRules));
              }
            )
          )
        },
        params: {
          linkTitle: 'Booking Rules',
          pageTitle: 'Booking Rules',
          userPermissionLvlRequired: ['Admin']
        }
      })

      .state('app.admin.companyProfile', {
        url: '/company-profile',
        template: '<sct-company-profile/>',
        resolve: {
          async: route(callback =>
            require.ensure([], () => {
                const component = require('../components/sct/sctAdmin/sctCompanyProfile/sctCompanyProfile').name;
                callback(app.register(component));
              }
            )
          )
        },
        params: {
          linkTitle: 'Company Profile',
          pageTitle: 'Company Profile',
          tab: null,
          userPermissionLvlRequired: ['Admin']
        }
      })

      .state('app.user', {
        abstract: true,
        template: '<sct-user/>',
        resolve: {
          async: route(callback =>
            require.ensure([], () => {
                const component = require('../components/sct/sctUser/sctUser').name;
                callback(app.register(component));
              }
            )
          )
        },
        url: '/user',
        params: {
          bodyClass: 'bg-sct'
        }
      })

      .state('app.user.contact', {
        url: '/contact',
        template: '<sct-contact/>',
        resolve: {
          async: route(callback =>
            require.ensure([], () => {
                const component = require('../components/sct/sctUser/sctContact/sctContact').name;
                callback(app.register(component));
              }
            )
          )
        },
        params: {
          linkTitle: 'Contact',
          pageTitle: 'Contact'
        }
      })

      .state('app.user.support', {
        url: '/support',
        template: '<sct-support/>',
        resolve: {
          async: route(callback =>
            require.ensure([], () => {
                const component = require('../components/sct/sctUser/sctSupport/sctSupport').name;
                callback(app.register(component));
              }
            )
          )
        },
        params: {
          linkTitle: 'Support',
          pageTitle: 'Support',
        }
      })

      .state('app.user.faq', {
        url: '/faq',
        template: '<sct-f-a-q/>',
        resolve: {
          async: route(callback =>
            require.ensure([], () => {
                const component = require('../components/sct/sctUser/sctFAQ/sctFAQ').name;
                callback(app.register(component));
              }
            )
          )
        },
        params: {
          linkTitle: 'FAQ',
          pageTitle: 'FAQ'
        }
      });
  };

  LbRoutes.$inject = $inject;

  return LbRoutes;
};



// WEBPACK FOOTER //
// ./src/routes/routes.sct.js